import { useEffect, useState } from "react";
import api from "@/lib/api";
import { MiniPlay } from "@/components/FamilyVoices";
import { Bell } from "lucide-react";

const what = (v) => (v.kind === "message" ? "a laissé un mot doux"
  : v.kind === "song" ? `a chanté « ${v.song_title} »` : `a lu « ${v.story_title || "un conte"} »`);

export default function NewVoices({ patientId }) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get(`/patients/${patientId}/new-voices`).then((r) => {
      setItems(r.data);
      if (r.data.length) api.post(`/patients/${patientId}/new-voices/seen`).catch(() => {});
    }).catch(() => {});
  }, [patientId]);
  if (!items.length) return null;
  return (
    <div className="rounded-3xl bg-rose-50 border border-rose-200 p-6 mb-8 soft-in" data-testid="new-voices">
      <p className="flex items-center gap-2 font-serif-display text-xl mb-4"><Bell className="w-5 h-5 text-rose-400" /> Nouvelles voix des proches</p>
      <div className="space-y-2">
        {items.map((v) => (
          <div key={v.id} className="flex items-center gap-3 bg-white rounded-2xl p-3" data-testid={`new-voice-${v.id}`}>
            <MiniPlay url={v.audio_url} testId={`new-voice-play-${v.id}`} />
            <span className="text-gray-700"><b>{v.label}</b> {what(v)} · {new Date(v.created_at).toLocaleDateString("fr-FR")}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
